/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_VisitsInputs */

const en_for_whom_tag_visits = /** @type {(inputs: For_Whom_Tag_VisitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visits`)
};

const pl_for_whom_tag_visits = /** @type {(inputs: For_Whom_Tag_VisitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wizyty`)
};

/**
* | output |
* | --- |
* | "Visits" |
*
* @param {For_Whom_Tag_VisitsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_visits = /** @type {((inputs?: For_Whom_Tag_VisitsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_VisitsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_visits(inputs)
	return en_for_whom_tag_visits(inputs)
});